/* global Popper */
export class Popover {
  constructor (App, settings) {
    this.popOpts = {
      trigger: 'manual',
      html: 'true'
    };

    this.App = App;
    this.settings = settings || {};
    this.list = [];
  }

  tooltip (element, message, placement = false) {
    this.create(element, 'tooltip', message, placement);
  }

  buildPopover (element, type, message, placement = false) {
    if (!placement) {
      placement = $(element).data('position') || 'top';
    }

    if (!$(element).data('message') && !message) {
      switch (type) {
        case 'confirm': message = '¿Confirmar acción?'; break;
        case 'delete': message = '¿Eliminar registro?'; break;
      }
    } else {
      if ($(element).data('message')) {
        message = $(element).data('message');
      }
    }

    const index = this.list.length;
    let buttons = '';

    if (type === 'confirm' || type === 'delete') {
      buttons = `<div class="popper-buttons">
        <button role="popbut-yes" class="button" type="button">Sí</button>
        <button role="popbut-no" class="button" type="button">No</button>
      </div>`;
    }

    const html = `<div id="popper-${index}" class="popper">
      <div class="popper__arrow"></div>
      <div class="popper-content">
        <div class="popper-message">${message}</div>
        ${buttons}
      </div>
    </div>`;

    $(element).attr('popper-id', 'popper-' + index);

    return {
      id: 'popper-' + index,
      html: html,
      message: message,
      placement: placement,
      fixed: $(element).attr('fixed') === 'true'
    };
  }

  destroy (popperId) {
    const item = this.list.filter(item => item.id === popperId)[0];

    if (item) {
      const fixed = $(`[popper-id="${item.id}"]`).attr('fixed');
      if (fixed && fixed === 'true') {
        return;
      }

      item.popper.destroy();
      const popper = document.getElementById(popperId);
      if (popper) {
        popper.remove();
      }

      this.list = this.list.filter(item => item.id !== popperId);
      $(`[popper-id=${popperId}]`).removeAttr('popper-id');
    }
  }

  exists (popperId) {
    return this.list.filter(item => item.id === popperId)[0];
  }

  create (element, type, message = '', placement = false, callback = null) {
    if ($(element).attr('popper-id') && this.exists($(element).attr('popper-id'))) {
      return;
    } else {
      this.list.forEach((item) => {
        this.destroy(item.id);
      });
    }

    const data = this.buildPopover(element, type, message, placement);

    // $('body').append(data.html);
    $(element).parent().append(data.html);

    let popper = document.getElementById(data.id);

    const newPopper = new Popper(element, popper, {
      placement: data.placement,
      modifiers: {
        flip: {
          behavior: ['left', 'bottom', 'top', 'right']
        },
        preventOverflow: {
          boundariesElement: document.querySelector('body')
        }
      }
    });

    this.bindButtons(data.id, element, type, callback);

    if (!data.fixed) {
      this.bindDismiss(data.id);
    }

    this.list.push({
      id: data.id,
      popper: newPopper
    });
  }

  bindButtons (popperId, button, type, callback = false) {
    const self = this;
    const url = $(button).attr('href');
    const loader = $(button).attr('loader') || false;
    const popper = $(`#${popperId}`);

    popper.find('[role=popbut-yes]')
      .unbind('click')
      .on('click', function () {
        self.App.jsonLink(url, false, false, loader, (data) => {
          self.handleResult(data, popperId, button, type, callback);
        }, button);
      });

    popper.find('[role=popbut-no]')
      .unbind('click')
      .on('click', function () {
        self.destroy(popperId);
      });
  }

  bindDismiss (popperId) {
    $('body, html, .modal-content')
      .unbind('click.dismiss-popover-' + popperId)
      .on('click.dismiss-popover-' + popperId, (event) => {
        event.stopPropagation();
        const selectors = [];
        const settings = this.settings;

        selectors.push('.popper-content');
        if (settings.confirm.selector) {
          selectors.push(settings.confirm.selector);
        }

        if (settings.delete.selector) {
          selectors.push(settings.delete.selector);
        }

        if (settings.activate.selector) {
          selectors.push(settings.activate.selector);
        }

        selectors.push('.popper-buttons');

        if (!$(event.target).is(selectors.join(','))) {
          this.destroy(popperId);
          $('body, html, .modal-content').unbind('click.dismiss-popover-' + popperId);
        }
      });
  }

  handleResult (data, popperId, button, type, callback = false) {
    const settings = this.settings;

    if (data.error === false) {
      if ($(button).attr('close-modal') || $(button).attr('close-modal') === 'true') {
        if (this.App.modal) {
          this.App.modal.close();
        }
      }

      if (($(button).attr('remove') || $(button).attr('remove') !== '') && type === 'delete') {
        $($(button).attr('remove')).remove();
      }

      if (!$(button).attr('destroy') && $(button).attr('destroy') !== 'false') {
        this.destroy(popperId);
      }

      if ($(button).attr('after-submit')) {
        this.App._runFuncByName($(button).attr('after-submit'), window, data);
      }

      if (callback) {
        callback(data);
      }
    } else {
      if ($(`#${popperId}`).find(`.${settings.feedback.class}`).length === 0) {
        $(`#${popperId}`).children('.popper-content')
          .append(`<div class="${settings.feedback.class}"></div>`);
      }

      if ($(button).attr('after-error')) {
        this.App._runFuncByName($(button).attr('after-error'), window, data);
      }

      $(`#${popperId}`).find(`.${settings.feedback.class}`)
        .removeClass(settings.feedback.correct_class)
        .addClass(settings.feedback.error_class)
        .html(data.msg)
        .fadeIn();
    }
  }
}



// WEBPACK FOOTER //
// ./devel/js/modules/popover.js